/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';

interface CarouselContext {
    direction?: string;
}

// Create a context wrapping some shared state
export default React.createContext<CarouselContext>({
    direction: 'right'
});
